import { FeaturesNames } from 'src/definitions/custom-models';
import { useFeatureFlags } from './useFeatureFlags';

export const useFeatureFlag = (
  featureName: FeaturesNames,
  subFeatureOrFalseIfDoesNotExist?: string | boolean,
  falseIfDoesNotExists?: boolean
): boolean => {
  const subFeature =
    subFeatureOrFalseIfDoesNotExist && isString(subFeatureOrFalseIfDoesNotExist)
      ? subFeatureOrFalseIfDoesNotExist
      : undefined;
  const setFalseIfDoesNotExists =
    subFeatureOrFalseIfDoesNotExist && isBool(subFeatureOrFalseIfDoesNotExist)
      ? subFeatureOrFalseIfDoesNotExist
      : falseIfDoesNotExists;

  const { isEnabled, isEnabledSubFeature } = useFeatureFlags(setFalseIfDoesNotExists);
  return subFeature ? isEnabledSubFeature(featureName, subFeature) : isEnabled(featureName);
};

function isString(x: string | boolean): x is string {
  return typeof x === 'string';
}
function isBool(x: string | boolean): x is boolean {
  return typeof x !== 'string';
}
